export default function getInputErrors({ touched = {}, errors = {}, inputName = '' }) {
  return (inputName && touched?.[inputName] && errors?.[inputName]) ? [errors?.[inputName]] : [];
}